exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h2.answer_upload_title[data-v-501b3349]{padding-left:56px!important;text-indent:-56px!important}.dropbox[data-v-501b3349]{outline:2px dashed grey;outline-offset:-10px;background:#e0ffff;color:dimgray;padding:10px;min-height:200px;position:relative;cursor:pointer}.input-file[data-v-501b3349]{opacity:0;width:100%;height:200px;position:absolute;cursor:pointer}.dropbox[data-v-501b3349]:hover{background:#add8e6}.dropbox p[data-v-501b3349]{font-size:1.2em;text-align:center;padding:50px 0}.modal-container[data-v-501b3349]{width:500px!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-501b3349","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/question/AnswerUpload.vue
// module id = 126
// module chunks = 0